import { BuildingTypeEnum, Search } from "@/types/types";
import styles from "../page-searchbar.module.css";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";

export default function BuildingTypeSelectorServer({
  t,
  activeBuildingType,
}: {
  t: any;
  activeBuildingType: BuildingTypeEnum | null;
}) {
  return (
    <div className={`${styles.selectWrapper} ${styles.typeItemWrapper}`}>
      <button className={styles.pill}>
        <div className={styles.textWrapper}>
          <span>
            {activeBuildingType !== null && activeBuildingType !== undefined
              ? t(activeBuildingType)
              : t("buildingTypeTitle")}
          </span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
    </div>
  );
}
